export function roundUp(n, factor) {
	return Math.ceil(n / factor) * factor
}

export function roundTo(n, factor) {
	return Math.round(n / factor) * factor
}
